import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaUsers } from 'react-icons/fa';
import { FiEdit, FiCopy, FiInfo } from 'react-icons/fi'
import { AiOutlineUserAdd } from 'react-icons/ai'
import { RxEnter } from 'react-icons/rx'
import { CgPlayListAdd } from 'react-icons/cg'
import { BsTrash } from 'react-icons/bs'
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import './index.css'
import '../main.css'
import { GetLeaguesByIds, GetUser, GetLeagues, CreateLeague, EditLeague, DeleteLeague, GetNextEvent, AddTeam, GetDisabled } from '../../ApiRequests'
import Cookies from 'universal-cookie';
import cookieUtils from "../../Utilities/CookieUtils";
import Helmet from 'react-helmet'

const Leagues = (props) => {
    const cookies = new Cookies()
    const cookie = cookies.get('jwt')
    const { scope, userId } = cookieUtils.getScopeFromJWT(cookie)

    const URL = process.env.REACT_APP_FRONT_END_URL

    const navigate = useNavigate()
    const storageUserId = localStorage.getItem('userID')
    const [leagues, setLeagues] = useState([])
    const [userLeagues, setUserLeagues] = useState([])
    const [userTeams, setUserTeams] = useState([])
    const [user, setUser] = useState([])
    const [showCreateLeague, setShowCreateLeague] = useState(false)
    const [showEditLeague, setShowEditLeague] = useState(false)
    const [leagueName, setLeagueName] = useState('')
    const [description, setDescription] = useState('')
    const [restriction, setRestriction] = useState('')
    const [numMaleRiders, setNumMaleRiders] = useState(4)
    const [numFemaleRiders, setNumFemaleRiders] = useState(2)
    const [privateLeague, setPrivateLeague] = useState('')
    const [showDeleteLeague, setShowDeleteLeague] = useState(false)
    const [leagueId, setLeagueId] = useState('')
    const [nextEvent, setNextEvent] = useState({})
    const [copied, setCopied] = useState(false)
    const [showAllLeagues, setShowAllLeagues] = useState(false)
    const [editingDisabled, setEditingDisabled] = useState(true)

    const visibleLeagues = showAllLeagues ? leagues : leagues.slice(0, 25)

    const getLeagues = async () => {
        const response = await GetLeagues()
        if (response == null) { return }
        const sortedLeagues = response.data.sort((a, b) => a.name.localeCompare(b.name));

        setLeagues(sortedLeagues)
    }

    const getUser = async () => {
        const userId = localStorage.getItem('userID')
        const userData = await GetUser(userId)

        if (!userData) { return }
        if ('data' in userData) {
            return userData.data
        } else {
            console.log('user has no data')
            return null
        }
    }

    const getUserLeagues = async () => {
        //get all leagues that a user is apart of. 
        const userData = await getUser()
        if (!userData) { return }
        if (!'teams' in userData) {
            console.log("NO TEAMS IN USER")
            return
        }
        setUser(userData)
        if (!Array.isArray(userData.teams)) {
            return null
        }
        setUserTeams(userData.teams)
        const leagueIds = userData.teams.map((team) => team.leagueId)
        setUserLeagues(leagueIds)
    }

    const getEditingDisabled = async () => {
        const res = await GetDisabled()
        if (!res || !res.data) {
            console.log("NO DATA")
            return
        }

        setEditingDisabled(res.data.disabled)
    }

    const goToLeague = (id) => {
        navigate(`/League?leagueId=${id}`)
    }


    const editMyTeam = (teamId, leagueId) => {
        navigate(`/EditTeam?teamId=${teamId}&leagueId=${leagueId}`)
    }


    const joinLeague = (id) => {
        navigate(`/CreateTeam?leagueId=${id}`)
    }


    const createLeague = async () => {
        const _league = {
            name: leagueName,
            description: description,
            private: privateLeague,
            numberMaleRiders: numMaleRiders,
            numberFemaleRiders: numFemaleRiders,
            admin: [{ userId: user._id }]
        }
        const res = await CreateLeague(_league)
        //Add user team to the league
        if (res && res.data) {
            const _resLeague = res.data
            const _leagueId = _resLeague._id

            const _res = await saveTeam(_leagueId)

            if (res) {
                navigate(`/league?leagueId=${_leagueId}`)
            } else {
                setShowCreateLeague(false)
                getLeagues()
            }
        } else {
            console.log('could not create league')
            return
        }

        // if (res) {
        //     setShowCreateLeague(false)
        //     getLeagues()
        // } else {
        //     console.log('could not create league')
        //     return
        // }
    }

    const saveTeam = async (_leagueId) => {
        const data = {
            userId: user._id,
            leagueId: _leagueId,
            riders: []
        }

        const res = await AddTeam(data)

        return res
    }


    const getNextEvent = async () => {
        const res = await GetNextEvent()
        if (!res) { return }
        setNextEvent(res.data)
    }


    const formatDate = (dateString) => {
        if (!dateString) { return }
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${year}-${month}-${day}`;
    }


    const editLeague = async () => {
        const data = {
            description: description,
            private: privateLeague,
            leagueId: leagueId
        }

        const res = await EditLeague(data, userId)

        if (res) {
            await getLeagues()
            await getUserLeagues()
            setShowEditLeague(false)
        }
    }

    const InfoIcon = () => {
        const renderTooltip = (props) => (
            <Tooltip id="button-tooltip" {...props}>
                To share private league with friends, send them the League URL below.
            </Tooltip>
        );

        return (
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
            >
                <Button className='mb-1 mx-0 px-1 py-0' variant="Link">
                    <FiInfo></FiInfo>
                </Button>
            </OverlayTrigger>)
    };

    const deleteLeague = async () => {
        const res = await DeleteLeague(leagueId)

        if (res) {
            await getLeagues()
            await getUserLeagues()
            setShowDeleteLeague(false)
        }
        console.log("Could not delete league", leagueId)
    }

    const copyURL = async (url) => {
        navigator.clipboard.writeText(url)
            .then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 5000);
            })
            .catch((error) => {
                console.error('Failed to copy URL:', error);
            });

    }

    useEffect(() => {
        getLeagues()
        getUserLeagues()
        getNextEvent()
        getEditingDisabled()
    }, [])


    const renderUserLeagues = (league, index) => {
        const alreadyInLeague = userLeagues.includes(league._id) ? true : false;
        let matchingTeam = {}
        if (user && 'teams' in user) {
            matchingTeam = user.teams.find((team) => team.leagueId === league._id);
        }

        const teamId = matchingTeam ? matchingTeam.teamId : null

        let admin = false
        let scopeAdmin = scope == 'admin' ? true : false
        if (league && 'admin' in league) {
            admin = league.admin.find((admin) => admin.userId == storageUserId)
        }

        return (
            <div className="" key={index}>
                {alreadyInLeague &&
                    <Card className="mx-3 my-4 border-0 shadow">
                        <Card.Header as="h5" className="fs-6">
                            <div className="row">
                                <div className="col-sm-9">
                                    <FaUsers className="mb-1 me-1" />
                                    {league.name}
                                </div>
                                {(admin || scopeAdmin) &&
                                    <div className="col-sm-3 d-flex flex-row justify-content-end">
                                        <FiEdit className="me-3 hover-pointer" onClick={() => { setShowEditLeague(true); setLeagueId(league?._id); setDescription(league?.description); setPrivateLeague(league?.private) }}></FiEdit>
                                        <BsTrash className="me-3 hover-pointer" onClick={() => { setShowDeleteLeague(true); setLeagueId(league._id) }}></BsTrash>
                                    </div>}
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {league && 'private' in league && league.private &&
                                <div className="my-2 mb-3">
                                    <InfoIcon></InfoIcon>
                                    <Form.Label className="mt-1 fw-bold" style={{ fontSize: '14px' }}> League Url:</Form.Label>
                                    <div className="row">
                                        <div className="col-md"> <Form.Control type='text' className='fw-light' style={{ fontSize: '14px' }} disabled readOnly value={`${URL}/Login?leagueId=${league._id}`} ></Form.Control></div>
                                        <div className="col-md-2 py-2 py-sm-0">
                                            <Button variant="secondary" className='w-100' style={{ fontSize: '14px' }} onClick={() => copyURL(`${URL}/Login?leagueId=${league._id}`)}><FiCopy></FiCopy> Copy URL</Button>
                                        </div>
                                    </div>
                                </div>}
                            <div className="" style={{ fontSize: '15px' }}>{league.description}</div>
                            {/* <hr></hr> */}
                            <div className="row mt-3">
                                <div className="col-lg-6">
                                    <div className="d-flex flex-row justify-content-start">
                                        <div className="">
                                            <div className="fw-light" style={{ fontSize: '14px' }}>Next Event: {formatDate(nextEvent.date)}</div>
                                            <div className="fw-light" style={{ fontSize: '14px' }}>Players in League: {league.teams.length}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="row d-flex flex-row justify-content-end">
                                        <div className="col-md-3 col-12 p-0  d-flex align-items-center justify-content-center">
                                            <Button disabled={editingDisabled} className='mt-2 mx-md-2 ms-2  w-100' variant="outline-secondary" style={{ fontSize: '14px' }} onClick={() => editMyTeam(teamId, league._id)}><FiEdit size={20} className="mb-1 me-2"></FiEdit>Edit Team</Button>
                                        </div>
                                        <div className="col-md-3 col-12 p-0  d-flex align-items-center justify-content-center">
                                            <Button className='mt-2 mx-md-2 ms-2 w-100' variant="primary" style={{ fontSize: '14px' }} onClick={() => goToLeague(league._id)}><RxEnter size={20} className="mb-1 me-1"></RxEnter> View Team</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>

                }
            </div >
        )
    }

    const renderFeaturedLeagues = (league, index) => {
        const alreadyInLeague = userLeagues.includes(league._id) ? true : false;
        let admin = false
        let scopeAdmin = scope == 'admin' ? true : false
        if (league && 'admin' in league) {
            admin = league.admin.find((admin) => admin.userId == storageUserId)
        }

        const isPrivate = (league && !admin && 'private' in league && league.private) ? true : false
        const isFeatured = (league && 'featured' in league && league.featured) ? true : false
        return (
            <div className="" key={index}>
                {!alreadyInLeague && !isPrivate && isFeatured &&
                    <Card className="mx-3 my-4 border-0 shadow">
                        <Card.Header as="h5" className="fs-6">
                            <div className="row">
                                <div className="col-md-9">
                                    <FaUsers className="mb-1 me-1" />
                                    {league.name}
                                </div>
                                {(admin || scopeAdmin) &&
                                    <div className="col-md-3 d-flex flex-row justify-content-end">
                                        <FiEdit className="me-3 hover-pointer" onClick={() => { setShowEditLeague(true); setLeagueId(league?._id); setDescription(league?.description); setPrivateLeague(league?.private) }}></FiEdit>
                                        <BsTrash className="me-3 hover-pointer" onClick={() => { setShowDeleteLeague(true); setLeagueId(league?._id) }}></BsTrash>
                                    </div>}
                            </div>

                        </Card.Header>
                        <Card.Body>
                            {league && 'private' in league && league.private &&
                                <div className="my-2">
                                    <InfoIcon></InfoIcon>
                                    <Form.Label className="mt-1 fw-bold" style={{ fontSize: '14px' }}>League Url:</Form.Label>
                                    <div className="row">
                                        <div className="col-md"> <Form.Control type='text' disabled className='fw-light' readOnly value={`${URL}/Login?leagueId=${league._id}`} ></Form.Control></div>
                                        <div className="col-md-2 py-2 py-sm-0">
                                            <Button variant="secondary" className='w-100' style={{ fontSize: '14px' }} onClick={() => copyURL(`${URL}/Login?leagueId=${league._id}`)}><FiCopy></FiCopy> Copy URL</Button>
                                        </div>
                                    </div>

                                </div>}
                            <div className="" style={{ fontSize: '14px' }}>{league.description}</div>
                            <hr></hr>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="d-flex flex-row justify-content-start">
                                        <div className="">
                                            <div className="fw-light" style={{ fontSize: '14px' }}>Next Event: {formatDate(nextEvent.date)}</div>
                                            <div className="fw-light" style={{ fontSize: '14px' }}>Players in league: {league.teams.length}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    {
                                        alreadyInLeague ?
                                            <div className="row d-flex flex-row justify-content-end">
                                                <div className="col-md-3 p-0">
                                                    <Button className='mt-2 ms-md-4 ms-2' variant="outline-success">Edit my Team</Button>
                                                </div>
                                                <div className="col-md-3 p-0">
                                                    <Button className='mt-2 ms-2' variant="outline-success">Go to League</Button>
                                                </div>
                                            </div> :
                                            <div className="row d-flex flex-row justify-content-end">
                                                <div className="col-md-3 p-0">
                                                    <Button className='mt-2 ms-2' style={{ fontSize: '14px' }} variant="outline-primary" onClick={() => joinLeague(league?._id)}> <AiOutlineUserAdd size={18} className="me-2 mb-1"></AiOutlineUserAdd>Join League</Button>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                }
            </div >
        )
    }

    const renderLeagues = (league, index) => {
        const alreadyInLeague = userLeagues.includes(league._id) ? true : false;
        let admin = false
        let scopeAdmin = scope == 'admin' ? true : false
        if (league && 'admin' in league) {
            admin = league.admin.find((admin) => admin.userId == storageUserId)
        }

        const isPrivate = (league && !admin && 'private' in league && league.private) ? true : false

        return (

            <div className="" key={index}>
                {!alreadyInLeague && !isPrivate &&
                    <Card className="mx-3 my-4 border-0 shadow">
                        <Card.Header as="h5" className="fs-6">
                            <div className="row">
                                <div className="col-md-9">
                                    <FaUsers className="mb-1 me-1" />
                                    {league.name}
                                </div>
                                {(admin || scopeAdmin) &&
                                    <div className="col-md-3 d-flex flex-row justify-content-end">
                                        <FiEdit className="me-3 hover-pointer" onClick={() => { setShowEditLeague(true); setLeagueId(league?._id); setDescription(league?.description); setPrivateLeague(league?.private) }}></FiEdit>
                                        <BsTrash className="me-3 hover-pointer" onClick={() => { setShowDeleteLeague(true); setLeagueId(league?._id) }}></BsTrash>
                                    </div>}
                            </div>

                        </Card.Header>
                        <Card.Body>
                            {league && 'private' in league && league.private &&
                                <div className="my-2">
                                    <InfoIcon></InfoIcon>
                                    <Form.Label className="mt-1 fw-bold" style={{ fontSize: '14px' }}>League Url:</Form.Label>
                                    <div className="row">
                                        <div className="col-md"> <Form.Control type='text' disabled className='fw-light' style={{ fontSize: '14px' }} readOnly value={`${URL}/Login?leagueId=${league._id}`} ></Form.Control></div>
                                        <div className="col-md-2 py-2 py-sm-0">
                                            <Button variant="secondary" className='w-100' onClick={() => copyURL(`${URL}/Login?leagueId=${league._id}`)}><FiCopy></FiCopy> Copy URL</Button>
                                        </div>
                                    </div>

                                </div>}
                            <div className="row">
                                <div className="col-md">
                                    <div className="d-flex flex-row justify-content-start">
                                        <div className="">
                                            <div className="fw-light" style={{ fontSize: '14px' }}>{league.description}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="d-flex flex-row justify-content-md-end">
                                        <Button className='mt-2 ms-2' style={{ fontSize: '14px' }} variant="outline-primary" onClick={() => joinLeague(league?._id)}> <AiOutlineUserAdd size={18} className="me-2 mb-1"></AiOutlineUserAdd>Join League</Button>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                }
            </div >
        )
    }

    return (
        <div className="container container-background" style={{ minHeight: '100vh' }}>
            <Helmet>
                <title>Leagues - Downhill MTB Fantasy</title>
                <meta name="description" content="Join and create public or private leagues. Compete with your friends in downhill mountain biking fantasy." />
            </Helmet>
            <div className="mx-4 py-4 pt-5">
                <div className="row">
                    <div className="col-sm-8 fw-light">
                        <b className="fw-bold">Join</b> public leagues
                        <div className="">
                            <b className="fw-bold">Create</b> your own private or public league to compete against your friends!
                        </div>
                    </div>
                    <div className="col-sm-4 d-flex flex-row justify-content-sm-end mt-2 mt-sm-0">
                        <Button variant="dark" onClick={() => setShowCreateLeague(true)}><CgPlayListAdd size={20}></CgPlayListAdd> Create League</Button>
                    </div>
                </div>

            </div>
            {/* User leauges */}
            <div className="line-with-title-container">
                <hr></hr>
                <div className="title">My Leagues</div>
            </div>
            <div className="py-2">
                {Array.isArray(leagues) && leagues.map(renderUserLeagues)}
            </div>


            <div className="line-with-title-container">
                <hr></hr>
                <div className="title">Featured Leagues</div>
            </div>
            <div className="py-3">
                {Array.isArray(leagues) && leagues.map(renderFeaturedLeagues)}
            </div>

            <div className="line-with-title-container">
                <hr></hr>
                <div className="title">All Public Leagues</div>
            </div>

            {/* other leagues */}
            <div className="py-4">
                {Array.isArray(visibleLeagues) && visibleLeagues.map(renderLeagues)}
                <div className="d-flex flex-row justify-content-sm-center">
                    {!showAllLeagues && <Button variant="outline-secondary" onClick={() => setShowAllLeagues(true)}>Show More</Button>}
                    {showAllLeagues && <Button variant="outline-secondary" onClick={() => setShowAllLeagues(false)}>Show Less</Button>}
                </div>
            </div>

            <Modal show={showCreateLeague} onShow={() => setPrivateLeague(false)} onHide={() => setShowCreateLeague(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create League</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="Name of your league..." value={leagueName} onChange={(e) => { setLeagueName(e.target.value) }} />
                    <br />
                    <Form.Label>Description</Form.Label>
                    <Form.Control type="text" value={description} placeholder='Describe your league...' onChange={(e) => setDescription(e.target.value)} />
                    <br />
                    <Form.Label className="fw-light mt-2">*NOTE: Total riders, male and female, must equal 6. </Form.Label>
                    <Form.Label>Number of male riders per Team</Form.Label>
                    <Form.Control type="number" placeholder="4" value={numMaleRiders} onChange={(e) => { setNumMaleRiders(parseInt(e.target.value)) }} />
                    <br />
                    <Form.Label>Number of female riders per Team</Form.Label>
                    <Form.Control type="number" placeholder="2" value={numFemaleRiders} onChange={(e) => setNumFemaleRiders(parseInt(e.target.value))} />
                    <br />
                    <Form.Label>League Privacy Setting:</Form.Label>
                    <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        label={`${privateLeague ? 'private' : 'public'}`}
                        onChange={() => setPrivateLeague(!privateLeague)}
                    />
                    {
                        privateLeague &&
                        <div className="fw-light mt-2 ml-2">A private link will be generated to be shared with you friends. </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateLeague(false)}>
                        Close
                    </Button>
                    <Button variant="outline-primary" disabled={leagueName == '' || description == '' || (numMaleRiders + numFemaleRiders != 6)} onClick={() => createLeague()}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showDeleteLeague} onHide={() => setShowDeleteLeague(false)}>
                <Modal.Header closeButton>
                    <BsTrash size={24} className="me-2"></BsTrash>
                    <Modal.Title>Delete League</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Are you sure you want to delete this league? </Form.Label>
                    <Form.Label>Deleting a league is permanent and the league cannot be recovered. </Form.Label>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteLeague(false)}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => deleteLeague()}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>



            <Modal show={showEditLeague} onHide={() => setShowEditLeague(false)}>
                <Modal.Header closeButton>
                    <FiEdit size={24} className="me-2"></FiEdit>
                    <Modal.Title>Edit League</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Description</Form.Label>
                    <Form.Control type="text" value={description} placeholder='Describe your league...' onChange={(e) => setDescription(e.target.value)} />

                    <Form.Label className="mt-4">League Privacy Setting:</Form.Label>
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        label={`${privateLeague ? 'private' : 'public'}`}
                        onChange={() => setPrivateLeague(!privateLeague)}
                    />

                    {privateLeague &&
                        <>
                            <Form.Label className="mt-4">Private League URL:</Form.Label>
                            <div className="row">
                                <div className="col-md"> <Form.Control type='text' className="fw-light" disabled readOnly value={`${URL}/Login?leagueId=${leagueId}`} ></Form.Control></div>
                                <div className="col-md-4 py-2 py-sm-0">
                                    <Button variant="secondary" className='' onClick={() => copyURL(`${URL}/Login?leagueId=${leagueId}`)}><FiCopy></FiCopy> Copy URL</Button>
                                </div>
                            </div>
                        </>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditLeague(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => editLeague()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className="" style={{
                position: 'fixed',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: '9999',
            }}>
                <Alert variant="success" show={copied} sticky='top' onClose={() => setCopied(false)} dismissible>
                    League URL copied to clipboard!
                </Alert>
            </div>
            <div className="" style={{
                position: 'fixed',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: '9999',
            }}>
                <Alert variant="danger" show={(numMaleRiders + numFemaleRiders != 6)} sticky='top' >
                    Total number of riders, male and female, must equal 6.
                </Alert>
            </div>
        </div>
    );
}
export default Leagues;